import { Map } from 'mapbox-gl';
import { mapColorPalette } from "../../../../../constants/Map";
import { IWellWaterSystemWCoordinates } from '../../../../../types';

export const updateGeoBlockStyles = (
    mapRef: React.RefObject<Map>,
    waterSystemGeoBlocks: IWellWaterSystemWCoordinates[],
    geoBlocksUnitsRef: React.MutableRefObject<IWellWaterSystemWCoordinates[] | null>,
    prevSelectedCounty: React.MutableRefObject<string | null | undefined>,
  ): void => {
    if (!Array.isArray(waterSystemGeoBlocks) || 
        !mapRef.current?.isStyleLoaded()) {
      return;
    } 
    
    prevSelectedCounty.current = null;
    geoBlocksUnitsRef.current = waterSystemGeoBlocks;

    
    const geojsonData = {
      type: 'FeatureCollection' as const,
      features: waterSystemGeoBlocks.map(block => ({
        type: 'Feature' as const,
        geometry: block.GEO_BLOCK.geometry,
        properties: {
          name: block.GEOID_BlkGrp,
          state: block.State,
          predClass: block.Pred_Class
        }
      }))
    };
  
    // Initialize the source if it doesn't exist
    if (!mapRef.current.getSource('maine')) {
      mapRef.current.addSource('maine', {
        type: 'geojson',
        data: geojsonData
      });

      // Add a fill layer for the polygons
      mapRef.current.addLayer({
        id: 'maine',
        type: 'fill',
        source: 'maine',
        paint: {
          'fill-opacity': 0.7,
          'fill-outline-color': '#000'
        }
      });
    } else {
      // Update existing source
      (mapRef.current.getSource('maine') as mapboxgl.GeoJSONSource).setData(geojsonData);
    }
  
    const blockColorMapping = waterSystemGeoBlocks.reduce<Record<string, string>>((acc, block, index) => {
      if (!block?.GEOID_BlkGrp) return acc;
      acc[block.GEOID_BlkGrp] = mapColorPalette[index % mapColorPalette.length] || '#d1d1d1';
      return acc;
    }, {});
    mapRef.current.setPaintProperty('maine', 'fill-color', [
      'match',
      ['get', 'name'],      
      ...(Object.entries(blockColorMapping).length > 0 
        ? Object.entries(blockColorMapping).flat() 
        : ['', '#fff']),
      '#fff',
    ]);
  };